import { render, staticRenderFns } from "./SetDunningBlockDialog.vue?vue&type=template&id=35b1e2e8&"
import script from "./SetDunningBlockDialog.vue?vue&type=script&lang=js&"
export * from "./SetDunningBlockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports